<template>
  <div>
    <a-spin tip="資料處理中..." :spinning="iconLoading">
    <div class="text-left">
            <a-input-search
              placeholder="請輸入姓名、手機號碼或身分證"
              style="margin: 10px; width: 350px;"
              enter-button
              @search="onSearch"
            />
          </div>
          <div v-if="udata.length > 0">            
            <a-table
              :columns="columns"
              :row-key="(record) => record.id"
              :data-source="udata"
              :pagination="upagination"
              :loading="uloading"
              @change="uhandleTableChange"
              bordered
            >
              <template slot="pri_url" slot-scope="pri_url">
                <b-avatar
                  :src="pri_url"
                  variant="primary"
                  text
                  size="2rem"
                  class="align-baseline"
                ></b-avatar>
              </template>
              <template slot="username" slot-scope="record">
                <div>
                  <span
                    v-if="record.username != ''"
                    style="color: #f08c3c"
                    v-text="record.username"
                  ></span>
                </div>
              </template>
              <template slot="display_name" slot-scope="record">
                <div>
                  <span
                    v-if="record.display_name != ''"
                    style="color: #2c7190"
                    v-text="record.display_name"
                  ></span>
                </div>
              </template>               
              <template slot="birth" slot-scope="record">
                <div>
                  <span
                    v-if="record.birth != ''"
                    style="color: #2c7190"
                    v-text="record.birth"
                  ></span>
                </div>
              </template>
              <template slot="address" slot-scope="record">
                <div>
                  <span
                    v-if="record.address != ''"
                    style="color: #2c7190"
                    v-text="record.address"
                  ></span>
                </div>
              </template>                           
              <template slot="qr" slot-scope="record">
                <div>
                    <a-button type="primary" icon="qrcode" :loading="iconLoading" @click="myCode(record)">
                        列印QRcode
                    </a-button>
                </div>
              </template>              
            </a-table>
          </div>
    <b-modal ref="my-qrs" centered @hide="onHide" id="modalQrXy" title hide-header hide-footer>
      <div class="text-center" id="cbodyer">
        <div v-if="!list" @click="toclose()" style="cursor: pointer;">
          <div class="qrheader" style="color: black;">
            <span v-text="'關閉QRCoder 請直接點選圖片'" />
            <a-button
              type="primary"
              icon="printer"
              style="margin-left: 1rem;font-size: 16px;color:black;"
              :loading="iconLoading2"
              @click="exportToPDF"
            >列印</a-button>
          </div>
          <div class="qrbody">
            <vue-qr
              ref="qrCode"
              :text="textValue"
              :logoScale="40"
              :size="450"
              :margin="10"
            />
            <div class="classempy" id="word1head" v-show="iconLoading2">
              <div id="word123" class="text-center">                
                <vue-qr
                  ref="qrCode"
                  :text="textValue"
                  :logoScale="40"
                  :size="650"
                  :margin="10"
                />
                <div style="font-size: 40px;font-weight: bold;margin-bottom: 2rem;" v-text="displayname"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    </a-spin>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { cmessService } from "../../../_services/";
//import * as moment from "moment/moment";
import html2pdf from "html2pdf.js";
import VueQr from "vue-qr";
import logoImg from "@/assets/lineicon.svg";

const queryuser = (params) => {
  return cmessService.findusListName(params.page, params.name);
};

const columns = [
  {
    title: "圖像",
    dataIndex: "pri_url",
    width: "15%",
    scopedSlots: { customRender: "pri_url" },
  },
  {
    title: "註冊帳號",
    dataIndex: "",
    scopedSlots: { customRender: "username" },
    width: "20%",
  },
{
    title: "Line顯示名稱",
    dataIndex: "",
    scopedSlots: { customRender: "display_name" },
    width: "15%",
  },  
  {
    title: "出生日期",
    dataIndex: "",
    scopedSlots: { customRender: "birth" },
    width: "15%",
  },
  {
    title: "地址",
    dataIndex: "",
    scopedSlots: { customRender: "address" },
    width: "25%",
  },      
  {
    title: "QRCode",
    dataIndex: "",
    scopedSlots: { customRender: "qr" },
    width: "10%",
  },  
  
];


export default {
  name: "SearchMan",
  components: {
    VueQr
  },
  data() {
    return {
      iconLoading: false,
      logoPath: logoImg,      
      columns,
      udata: [],
      upagination: { defaultPageSize: 4 },
      uloading: false,
      list: true,
      textValue: "",
      displayname: "",          
    };
  },
  mounted() {
    this.usfetch({ results: 4, page: 1, pageSize: 4, name: this.name });
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["datas", "defaultval"]),
  },

  methods: {   

    async onSearch(value) {
      if (value == "") {
        this.name = "all";
      } else {
        this.name = value;
      }
      await this.usfetch({ results: 4, page: 1, pageSize: 4, name: this.name });
    }, 
    
    uhandleTableChange(pagination, filters, sorter) {
      //console.log(pagination);
      const pager = { ...this.upagination };
      pager.current = pagination.current;
      this.upagination = pager;
      //console.log(this.pagination);
      this.usfetch({
        results: pagination.pageSize,
        name: this.name,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    
    usfetch(params = {}) {
      this.uloading = true;
      queryuser({
        //results: 4,
        ...params,
      }).then(({ data }) => {
        const pagination = { ...this.upagination };
        // Read total count from server
        // pagination.total = data.totalCount;
        pagination.total = data.info.totail;
        //pagination.total = 200;
        this.uloading = false;
        this.udata = data.results;
        this.upagination = pagination;
      });
    }, 
    
    maskName(name) {
            const len = name.length;
            const half = Math.ceil(len / 2);
            const maskedPart = '*'.repeat(half);
            const visiblePart = name.slice(half);
            return maskedPart + visiblePart;
    }, 

    myCode(record) {
      this.list = false;
      this.textValue = "actjoin:" + record.id;
      this.displayname = record.display_name;
      this.$refs["my-qrs"].show();
    }, 
    
    toclose() {
      this.list = true;
      this.$refs["my-qrs"].hide();
    },    

    onHide(evt) {
      if (evt.trigger === "backdrop") {
        evt.preventDefault();
      }
    },

    exportToPDF() {
      // pdf匯出設定
      this.iconLoading2 = true;
      const opt = {
        margin: 0.3,
        filename: "QRCode.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
      };
      this.domList = [];
      // 抓取各個圖片的DOM元素，並把它裝入doc這個陣列裡
      let newDiv = document.createElement("div");
      //let j = this.items.act_detrimal.length
      let head1 = document.getElementById("word1head");
      const clone1 = head1.cloneNode(true);
      newDiv.appendChild(clone1);
      let element1 = document.getElementById("word123");
      this.domList.push(element1);
      // 開始進行列印
      let doc = html2pdf()
        .from(this.domList[0])
        .set(opt)
        .toPdf();
      for (let j = 1; j < this.domList.length-1; j++) {
        doc = doc
          .get("pdf")
          .then(pdf => pdf.addPage())
          .from(this.domList[j])
          .toContainer()
          .toCanvas()
          .toPdf();
      }
      // 列印完成輸出done
      doc
        .save()
        .then(() => (this.iconLoading2 = false));
      //
    },     
  }
};
</script>
<style scoped>
.imgs {
  margin: 25%;
  width: 60px;
  height: 60px;
}
#cheader {
  margin: 0px auto;
  padding: 0px;
  background-color: #ffffff;
  width: 50%;
  border-top-left-radius: 10.5rem;
  border-top-right-radius: 10.5rem;
}
#cbodyer {
  padding: 10px;
  background-color: #ffffff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>
<style>
#modalQr > .modal-dialog > .modal-content > .modal-body {
  border-color: transparent;
  background-color: transparent !important;
  color: white;
}
#modalQr > .modal-dialog > .modal-content {
  border-color: transparent;
  background-color: transparent !important;
}
</style>